import React, { useEffect } from 'react';
import { useConsultationContext } from '../../../context/ConsultationContext';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import {
  getOtherServices,
  OtherServices,
  selectOtherServices,
} from '../../../store/slices/consultationOtherServices';
import { getPrescription } from '../../../store/slices/sickLeaveAndPrescription';
import { IAccountInfo, selectAccountInfo } from '../../../store/slices/auth';
import styles from './Preview.module.scss';
import { useTranslation } from '../../../hooks/useTranslations';

interface Props {
  style?: React.CSSProperties;
}

export default function Preview({ style }: Props) {
  const dispatch = useAppDispatch();
  const { selectedSalesOrder } = useConsultationContext();
  const sickLeaveAndPrescription = useAppSelector<any>((state) => state.sickLeaveAndPrescription);
  const otherServicesState: OtherServices[] = useAppSelector<OtherServices[]>(selectOtherServices);
  const accountInfo = useAppSelector<IAccountInfo>(selectAccountInfo);
  const { translations } = useTranslation();
   const language = localStorage.getItem('lang') ?? 'en';



  useEffect(() => {
    if (selectedSalesOrder.work_order.work_order_id) {
      dispatch(getOtherServices({ workOrderId: Number(selectedSalesOrder.work_order.work_order_id), language }));
      dispatch(getPrescription(selectedSalesOrder.work_order.work_order_id));
    }
  }, [selectedSalesOrder.work_order.work_order_id, language]);

  return (
    <div className={styles.container} style={style}>
      <p className={styles.title}>{translations('doctor.findings')}</p>
      <div className={styles.wrapper}>
        <PreviewCard
          title={translations('findings')}
          content={
            selectedSalesOrder?.consultation_findings?.consultation_findings_description ? (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    selectedSalesOrder?.consultation_findings?.consultation_findings_description ??
                    '',
                }}
              />
            ) : (
              ''
            )
          }
        />
        <PreviewCard
          title={translations('recommendations')}
          content={
            selectedSalesOrder?.consultation_recommendations
              ?.consultation_recommendations_description ? (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    selectedSalesOrder?.consultation_recommendations
                      ?.consultation_recommendations_description ?? '',
                }}
              />
            ) : (
              ''
            )
          }
        />
        <PreviewCard title={translations('label.attachment_description_prescriptions')} content={sickLeaveAndPrescription?.prescription} />
        {accountInfo.performs_other_services && (
          <PreviewCard
            title={translations('additional.services')}
            content={OtherServicesComponent(otherServicesState)}
          />
        )}
      </div>
    </div>
  );
}
const OtherServicesComponent = (content: any) => {
  const { translations } = useTranslation();

  return (
    <>
      {content.length ? (
        content.map((oServices: any) => (
          <div className={styles.divider}>
            <p>{translations('service')}: {oServices.service_name}</p>
            <p>{translations('remarks')}: {oServices.remarks}</p>
          </div>
        ))
      ) : (
        <p className={styles.emptyText}>{translations('filled')}</p>
      )}
    </>
  );
};

const PreviewCard = ({ title, content }: { title: string; content: string | React.ReactNode }) => {
  const { translations } = useTranslation();

  return (
    <div className={styles.previewCardItem}>
      <p className={styles.title}>{title}</p>
      <div className={styles.textArea} style={content ? { color: '#11131f' } : {}}>
        {content || <p className={styles.emptyText}>{translations('filled')}</p>}
      </div>
    </div>
  );
};
